import { NgModule } from "@angular/core";
import { RaskCommonModule } from "~app/common/rask-common.module";
import { ProduktDetailModule } from "./produkt-detail/produkt-detail.module";
import { ProduktSearchModule } from "./produkt-search/produkt-search.module";

@NgModule({
    declarations: [],
    imports: [
        RaskCommonModule,
        ProduktSearchModule,
        ProduktDetailModule
    ],
    providers: []
})
export class ProduktModule { }
